import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ba9700fc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ba9700fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9700fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba9700fc')) {
      api.createRecord('ba9700fc', component.options)
    } else {
      api.reload('ba9700fc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ba9700fc&scoped=true&", function () {
      api.rerender('ba9700fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z6ChLCLie0Mq/JS/comp/GuestBox.vue"
export default component.exports